var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 1.5C8.76562 1.5 5.34375 3.51562 3.46875 6.75C1.54688 10.0312 1.54688 14.0156 3.46875 17.25C5.34375 20.5312 8.76562 22.5 12.5625 22.5C16.3125 22.5 19.7344 20.5312 21.6094 17.25C23.5312 14.0156 23.5312 10.0312 21.6094 6.75C19.7344 3.51562 16.3125 1.5 12.5625 1.5ZM12.5625 24C8.25 24 4.3125 21.75 2.15625 18C0 14.2969 0 9.75 2.15625 6C4.3125 2.29688 8.25 0 12.5625 0C16.8281 0 20.7656 2.29688 22.9219 6C25.0781 9.75 25.0781 14.2969 22.9219 18C20.7656 21.75 16.8281 24 12.5625 24ZM11.8125 16.5V12.75H8.0625C7.64062 12.75 7.3125 12.4219 7.3125 12C7.3125 11.625 7.64062 11.25 8.0625 11.25H11.8125V7.5C11.8125 7.125 12.1406 6.75 12.5625 6.75C12.9375 6.75 13.3125 7.125 13.3125 7.5V11.25H17.0625C17.4375 11.25 17.8125 11.625 17.8125 12C17.8125 12.4219 17.4375 12.75 17.0625 12.75H13.3125V16.5C13.3125 16.9219 12.9375 17.25 12.5625 17.25C12.1406 17.25 11.8125 16.9219 11.8125 16.5Z",
    fill: "#00545E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.4dca13bc7584f718a6ed4bc359df72d3.svg";
export { ForwardRef as ReactComponent };